import TechSectionHeader from "./TechSectionHeader";
import TechStackGrid from "./TechStackGrid";
import { mobileTech } from "./technologies.data";

export default function TechMobile() {
  return (
    <section className="tech-section">
      <TechSectionHeader
        title="Mobile App"
        highlight="Technologies"
        subtitle="High-performance mobile apps with native-like experience."
      />

      <TechStackGrid items={mobileTech} />
    </section>
  );
}
